import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "mx-5" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { on: { showParent: _vm.showParent } })],
        1
      ),
      _vm.showParentPage
        ? _c(
            "div",
            [
              _c(
                VBreadcrumbs,
                [
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: { exact: true, to: { name: "home", params: {} } },
                    },
                    [_vm._v(" Home ")]
                  ),
                  _c(VBreadcrumbsDivider, [_vm._v("/")]),
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: {
                        exact: true,
                        to: { name: "inventoryLabResult", params: {} },
                        active: "",
                      },
                    },
                    [_vm._v(" Inventory Lab Result ")]
                  ),
                ],
                1
              ),
              _c("lab-result-missing-lots", {
                attrs: {
                  "start-date": _vm.appliedStart,
                  "end-date": _vm.appliedEnd,
                },
              }),
              _c(
                "div",
                { staticClass: "d-flex flex-column flex-lg-row mb-3" },
                [
                  _c(
                    VMenu,
                    {
                      ref: "startMenu",
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "290px",
                        "z-index": "100",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  VTextField,
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          label: "Start Date",
                                          "prepend-icon": "mdi-calendar",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.startDate,
                                          callback: function ($$v) {
                                            _vm.startDate = $$v
                                          },
                                          expression: "startDate",
                                        },
                                      },
                                      "v-text-field",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2402606358
                      ),
                      model: {
                        value: _vm.startMenu,
                        callback: function ($$v) {
                          _vm.startMenu = $$v
                        },
                        expression: "startMenu",
                      },
                    },
                    [
                      _c(
                        VDatePicker,
                        {
                          attrs: { max: _vm.endDate },
                          on: {
                            input: function ($event) {
                              _vm.startMenu = false
                            },
                          },
                          model: {
                            value: _vm.startDate,
                            callback: function ($$v) {
                              _vm.startDate = $$v
                            },
                            expression: "startDate",
                          },
                        },
                        [
                          _c(VSpacer),
                          _c(
                            VBtn,
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.startMenu = false
                                },
                              },
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.startMenu.save(_vm.startDate)
                                },
                              },
                            },
                            [_vm._v(" OK ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VMenu,
                    {
                      ref: "endMenu",
                      staticClass: "mx-2",
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "290px",
                        "z-index": "100",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  VTextField,
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          label: "End Date",
                                          "prepend-icon": "mdi-calendar",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.endDate,
                                          callback: function ($$v) {
                                            _vm.endDate = $$v
                                          },
                                          expression: "endDate",
                                        },
                                      },
                                      "v-text-field",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1090255446
                      ),
                      model: {
                        value: _vm.endMenu,
                        callback: function ($$v) {
                          _vm.endMenu = $$v
                        },
                        expression: "endMenu",
                      },
                    },
                    [
                      _c(
                        VDatePicker,
                        {
                          attrs: { min: _vm.startDate },
                          on: {
                            input: function ($event) {
                              _vm.endMenu = false
                            },
                          },
                          model: {
                            value: _vm.endDate,
                            callback: function ($$v) {
                              _vm.endDate = $$v
                            },
                            expression: "endDate",
                          },
                        },
                        [
                          _c(VSpacer),
                          _c(
                            VBtn,
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.endMenu = false
                                },
                              },
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.endMenu.save(_vm.endDate)
                                },
                              },
                            },
                            [_vm._v(" OK ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex flex-column flex-lg-row" },
                [
                  _c(VTextField, {
                    attrs: {
                      dense: "",
                      placeholder: "Press enter to begin search",
                      "append-icon": "mdi-magnify",
                      outlined: "",
                      clearable: "",
                      label:
                        "Search sample, document, program, quality, lot ID or lot document",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.search.apply(null, arguments)
                      },
                      "click:clear": _vm.clearSearch,
                      "click:append": _vm.search,
                    },
                    model: {
                      value: _vm.searchTerms,
                      callback: function ($$v) {
                        _vm.searchTerms = $$v
                      },
                      expression: "searchTerms",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-space-around" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass:
                            "ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start",
                          attrs: {
                            color: "primary",
                            to: {
                              name: "inventoryLabResultCreate",
                              params: {},
                            },
                          },
                        },
                        [_vm._v(" New Lab Result ")]
                      ),
                      _c(
                        VBtn,
                        {
                          staticClass:
                            "ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start",
                          attrs: {
                            color: "primary",
                            to: {
                              name: "inventoryLabResultUpload",
                              params: {},
                            },
                          },
                        },
                        [_vm._v(" Upload ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex flex-column flex-lg-row" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-2 mt-md-0",
                      attrs: { color: "primary" },
                      on: { click: _vm.applyDateRange },
                    },
                    [_vm._v(" Submit ")]
                  ),
                ],
                1
              ),
              _c(VDivider, { staticClass: "my-2" }),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-space-around flex-column flex-md-row align-items-center",
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-light mr-4 mt-1" },
                        [_vm._v("Display")]
                      ),
                      _c(VSwitch, {
                        staticClass: "mt-0 mx-2",
                        attrs: { value: true, label: "Unassigned Only" },
                        on: { change: _vm.search },
                        model: {
                          value: _vm.unassignedOnly,
                          callback: function ($$v) {
                            _vm.unassignedOnly = $$v
                          },
                          expression: "unassignedOnly",
                        },
                      }),
                      _c(
                        VTooltip,
                        {
                          attrs: {
                            top: "",
                            "max-width": "380",
                            "z-index": "20",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b({}, "div", attrs, false),
                                        on
                                      ),
                                      [
                                        _c(VSwitch, {
                                          staticClass: "mt-0 mx-2",
                                          attrs: {
                                            value: true,
                                            label: "Flagged Only",
                                          },
                                          on: { change: _vm.search },
                                          model: {
                                            value: _vm.flaggedOnly,
                                            callback: function ($$v) {
                                              _vm.flaggedOnly = $$v
                                            },
                                            expression: "flaggedOnly",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3263399134
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " Flagged = the report sits on a lot that its own worksheet number or document disagrees with, e.g. a FINAL on a dross lot, or a lot with another document. Hover the orange ⚠ on a row to see why. Click it to keep that lot, or click the lot number to choose the right one; either way the flag goes. "
                            ),
                          ]),
                        ]
                      ),
                      _c(VSwitch, {
                        staticClass: "mt-0 mx-2",
                        attrs: { value: true, label: "Final Test Only" },
                        on: { change: _vm.search },
                        model: {
                          value: _vm.finalTestOnly,
                          callback: function ($$v) {
                            _vm.finalTestOnly = $$v
                          },
                          expression: "finalTestOnly",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-4 mt-2 mt-md-0",
                      attrs: {
                        color: "primary",
                        outlined: "",
                        disabled: _vm.isAutoAssigning,
                      },
                      on: { click: _vm.autoAssign },
                    },
                    [
                      _c(VIcon, { attrs: { left: "" } }, [
                        _vm._v("mdi-link-variant"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isAutoAssigning
                              ? `Auto-assigning ${_vm.autoAssignProgress}`
                              : "Auto-assign Inventory"
                          ) +
                          " "
                      ),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-4 mt-2 mt-md-0",
                      attrs: { color: "secondary", loading: _vm.isDownloading },
                      on: { click: _vm.downloadAll },
                    },
                    [_vm._v(" Download All Results ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c("div", { staticClass: "d-flex justify-end my-2" }),
                  _c(VDataTable, {
                    staticClass: "elevation-1",
                    attrs: {
                      id: "lab-results-table",
                      headers: _vm.headers,
                      items: _vm.inventoryLabResultList,
                      options: _vm.options,
                      "items-per-page": _vm.pagination.pageSize,
                      loading: !_vm.inventoryLabResultProcessed,
                      "server-items-length": _vm.pagination.totalSize,
                      page: _vm.pagination.current,
                      "item-key": "id",
                      "footer-props": {
                        "items-per-page-options": [
                          10, 20, 30, 40, 50, 100, 500,
                        ],
                      },
                    },
                    on: {
                      "update:options": [
                        function ($event) {
                          _vm.options = $event
                        },
                        _vm.pageChanged,
                      ],
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.inventoryId",
                          fn: function ({ item }) {
                            return [
                              item.inventoryId
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              _vm.selectedRow = item
                                              _vm.lookupInventory = true
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.inventoryId))]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "certificate-icon-wrapper",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPreview(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VBadge,
                                            {
                                              attrs: {
                                                content: "✔",
                                                value: item.signed,
                                                color: "green",
                                                overlap: "",
                                                bottom: "",
                                                right: "",
                                              },
                                            },
                                            [
                                              _c(
                                                VIcon,
                                                { staticClass: "ml-2" },
                                                [_vm._v("mdi-certificate")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      item.lotCheck
                                        ? _c(
                                            VTooltip,
                                            {
                                              attrs: {
                                                right: "",
                                                "max-width": "360",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          VIcon,
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "ml-2",
                                                                attrs: {
                                                                  color:
                                                                    "orange darken-2",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmLot(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " mdi-alert-circle "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(item.lotCheck) +
                                                    ". Click to keep it on this lot."
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "a",
                                    {
                                      staticStyle: { "white-space": "nowrap" },
                                      on: {
                                        click: function ($event) {
                                          _vm.lookupInventory = true
                                          _vm.selectedRow = item
                                        },
                                      },
                                    },
                                    [_vm._v("Assign")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: "item.testTime",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "a",
                                {
                                  staticStyle: { "white-space": "nowrap" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatDateTimeYear")(
                                          item.testTime
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.finalTest",
                          fn: function ({ item }) {
                            return [
                              item.finalTest
                                ? _c(VIcon, [_vm._v("mdi-check")])
                                : _c(VIcon, [_vm._v("mdi-close")]),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "white-space": "nowrap" } },
                                [
                                  _c(
                                    VIcon,
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" mdi-pencil ")]
                                  ),
                                  _c(
                                    VIcon,
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.remove(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" mdi-delete ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2038379181
                    ),
                  }),
                  _c(
                    "div",
                    { staticClass: "my-5" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { name: "inventoryCoaCheck", params: {} },
                          },
                        },
                        [_vm._v(" Find inventory without CoA ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("confirmation-dialog", { ref: "confirm" }),
      _c("lab-result-lot-chooser", {
        attrs: {
          activated: _vm.lookupInventory,
          "lab-result": _vm.selectedRow,
        },
        on: {
          "update:activated": function ($event) {
            _vm.lookupInventory = $event
          },
          chosen: _vm.assignChosenLot,
          unassign: _vm.leaveUnassigned,
        },
      }),
      _c("lab-result-review-dialog", {
        attrs: {
          activated: _vm.reviewOpen,
          "start-date": _vm.startDate,
          "end-date": _vm.endDate,
        },
        on: {
          "update:activated": function ($event) {
            _vm.reviewOpen = $event
          },
          changed: _vm.getResources,
        },
      }),
      _c(
        VDialog,
        {
          attrs: { "max-width": "1200px", persistent: "" },
          model: {
            value: _vm.previewDialog,
            callback: function ($$v) {
              _vm.previewDialog = $$v
            },
            expression: "previewDialog",
          },
        },
        [
          _c("coa-preview", {
            key: _vm.selectedLabResult ? _vm.selectedLabResult.id : "",
            attrs: { "lab-result": _vm.selectedLabResult },
            on: {
              close: function ($event) {
                _vm.previewDialog = false
              },
              signed: _vm.handleSigned,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }